import React, { Component } from "react";
import { Grid } from "@mui/material";
import { CareersButton, Logo } from "../exports/Components";
import "../assets/css/PortraitHeader.css";

class PortraitHeader extends Component {
  render() {
    const { renderPortraitHeader } = this;
    return renderPortraitHeader();
  }

  renderPortraitHeader = () => {
    const { renderLogo, renderCareersButton } = this;
    return (
      <Grid container justifyContent="space-between">
        {renderLogo()}
        {renderCareersButton()}
      </Grid>
    );
  };

  renderLogo = () => {
    return (
      <Grid className="portrait-header-logo" item xs={5}>
        <Logo />
      </Grid>
    );
  };

  renderCareersButton = () => {
    return (
      <Grid
        className="portrait-header-button"
        container
        item
        xs={3}
        justifyContent="flex-end"
      >
        <CareersButton {...this.props} />
      </Grid>
    );
  };
}

export default PortraitHeader;
